import { render, staticRenderFns } from "./ListaFornecedor.vue?vue&type=template&id=77ce59c6&scoped=true"
import script from "./ListaFornecedor.vue?vue&type=script&lang=js"
export * from "./ListaFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ListaFornecedor.vue?vue&type=style&index=0&id=77ce59c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ce59c6",
  null
  
)

export default component.exports